import {Component} from 'react'
import Loader from 'react-loader-spinner'
import Cookies from 'js-cookie'
import {Redirect} from 'react-router-dom'
import {AiFillStar} from 'react-icons/ai'
import {MdLocationOn} from 'react-icons/md'
import {FaToolbox} from 'react-icons/fa'
import {RiShareForwardBoxFill} from 'react-icons/ri'
import SimilarJobs from '../SimilarJobs'
import Navbar from '../Navbar'
import './index.css'

class JobItemDetails extends Component {
  state = {jobDetails: {}, similarJobDetails: [], isLoading: true}

  componentDidMount() {
    this.getSpecificJobDetails()
  }

  updateDetails = details => ({
    companyLogoUrl: details.company_logo_url,
    companyWebsiteUrl: details.company_website_url,
    employmentType: details.employment_type,
    id: details.id,
    jobDescription: details.job_description,
    lifeAtCompany: details.life_at_company,
    location: details.location,
    packagePerAnnum: details.package_per_annum,
    rating: details.rating,
    skills: details.skills,
    title: details.title,
  })

  getSpecificJobDetails = async () => {
    const {match} = this.props
    const {params} = match
    const {id} = params
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }
    const url = `https://apis.ccbp.in/jobs/${id}`
    const response = await fetch(url, options)
    const retrievedData = await response.json()
    const retrievedJobDetails = retrievedData.job_details
    const retrievedSimilarJobs = retrievedData.similar_jobs
    const updatedData = this.updateDetails(retrievedJobDetails)
    const updatedSimilarJobs = retrievedSimilarJobs.map(each =>
      this.updateDetails(each),
    )
    this.setState({
      jobDetails: updatedData,
      similarJobDetails: updatedSimilarJobs,
      isLoading: false,
    })
  }

  displaySKills = skill => (
    <li className="skill-list-item">
      <img className="skill-image" src={skill.image_url} alt={skill.name} />
      <p className="skill-name">{skill.name}</p>
    </li>
  )

  renderLoading = () => (
    <div className="loader-container" data-testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  renderJobDetails = () => {
    const {jobDetails, similarJobDetails} = this.state
    const {
      title,
      companyLogoUrl,
      companyWebsiteUrl,
      employmentType,
      jobDescription,
      location,
      packagePerAnnum,
      rating,
      skills,
      lifeAtCompany,
    } = jobDetails
    const jwtToken = Cookies.get('jwt_token')
    if (jwtToken === undefined) {
      return <Redirect to="/login" />
    }

    return (
      <>
        <div className="jobs-list-item">
          <div className="top-container">
            <img
              className="company-logo"
              src={companyLogoUrl}
              alt="job details company logo"
            />
            <div className="title-card">
              <h1 className="title">{title}</h1>
              <div className="rating-card">
                <AiFillStar color="#fbbf24" height="20" width="20" />
                <p className="rating">{rating}</p>
              </div>
            </div>
          </div>
          <div className="middle-container">
            <div className="middle-card">
              <MdLocationOn color="#ffffff" height="20" width="20" />
              <p className="location">{location}</p>
              <FaToolbox color="#ffffff" height="20" width="20" />
              <p className="type-of-employment">{employmentType}</p>
            </div>
            <p className="package">{packagePerAnnum}</p>
          </div>
          <hr className="horizontal-line" />
          <div className="description-container">
            <h1 className="description">Description</h1>
            <div className="visit-card">
              <a href={companyWebsiteUrl} className="visit-text">
                Visit
              </a>
              <RiShareForwardBoxFill color="#2c364c" height="20" width="20" />
            </div>
          </div>
          <p className="job-description">{jobDescription}</p>
          <h1 className="skill">Skills</h1>
          <ul className="skill-container">
            {skills.map(each => this.displaySKills(each))}
          </ul>
          <h1 className="skill">Life at Company</h1>
          <div className="life-at-company-container">
            <p className="life-description">{lifeAtCompany.description}</p>
            <img
              className="life-image"
              src={lifeAtCompany.image_url}
              alt="life at company"
            />
          </div>
        </div>
        <h1 className="skill">Similar Jobs</h1>
        <ul>
          {similarJobDetails.map(eachJob => (
            <SimilarJobs key={eachJob.id} similarJob={eachJob} />
          ))}
        </ul>
      </>
    )
  }

  render() {
    const {isLoading} = this.state

    return (
      <>
        <Navbar />
        <div className="job-item">
          {isLoading && this.renderLoading()}
          {isLoading === false && this.renderJobDetails()}
        </div>
      </>
    )
  }
}
export default JobItemDetails
